import * as navigation from 'Navigation';

export default class ComplexPolymerMapTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Polymer Map',
      closeable: false,
      preferenceKey: 'complex-polymer-map',
    };
  }
}
